import classnames from 'classnames'
import React from 'react'

import TilesStore from '../../futures/stores/tilesStore'
import { FuturesTile } from '../../futures/types'
import { encodeQueryString } from '../../queryString'
import { ForexFuturesCryptoSettings } from '../../shared/components/ForexFuturesCryptoSettings'
import Sparkline from '../../shared/components/Sparkline'

const TILES_ORDER = ['EURUSD', 'GBPUSD', 'USDJPY', 'USDCAD', 'USDCHF', 'AUDUSD', 'NZDUSD', 'EURGBP', 'GBPJPY', 'BTCUSD']

function getTilesInOrder(tiles: Record<string, FuturesTile>) {
  return TILES_ORDER.map((key) => tiles[key])
}

interface ChartMenuProps {
  activeTile: string
  activeTimeframe: string
  activeRange: string
  type: string
  showChartControls?: boolean
  isRedesignEnabled?: boolean
}

export default function ChartMenu({
  activeTile,
  activeTimeframe,
  activeRange,
  type,
  showChartControls,
  isRedesignEnabled,
}: ChartMenuProps) {
  const isInteractiveActive = type === '1'
  const [tiles, setTiles] = React.useState(getTilesInOrder(TilesStore.getTiles()))

  React.useEffect(() => {
    const onStoreChange = () => setTiles(getTilesInOrder(TilesStore.getTiles()))

    TilesStore.addChangeListener(onStoreChange)

    return () => TilesStore.removeChangeListener(onStoreChange)
  }, [])

  const interactiveUrl = FinvizSettings.hasUserPremium
    ? `/forex_charts.ashx?${encodeQueryString({
        t: activeTile,
        p: activeTimeframe,
        ty: 1,
      })}`
    : `/elite.ashx?${encodeQueryString({
        utm_source: 'finviz',
        utm_medium: 'banner',
        utm_campaign: 'forex-interactive-chart',
      })}`

  const getTileHref = (ticker: string) =>
    `/forex_charts.ashx?${encodeQueryString({
      t: ticker,
      p: activeTimeframe,
      ty: isRedesignEnabled && isInteractiveActive ? undefined : type,
      r: activeRange,
    })}`

  return (
    <div className="chart-menu">
      {showChartControls && (
        <ul className="chart-menu_type">
          <li className={classnames('is-static', { 'is-active': !isInteractiveActive })}>
            <a
              href={`/forex_charts.ashx?${encodeQueryString({
                t: activeTile,
                p: activeTimeframe,
                ty: undefined,
                r: activeRange,
              })}`}
              data-testid="forex-static"
            >
              Static
            </a>
          </li>
          <li
            className={classnames('is-interactive flex items-center justify-between', {
              'is-active': isInteractiveActive,
            })}
          >
            <a className="grow" href={interactiveUrl} data-testid="forex-interactive">
              Interactive
            </a>
            {isInteractiveActive && (
              <ForexFuturesCryptoSettings isPremium={FinvizSettings.hasUserPremium} page="forex" />
            )}
          </li>
        </ul>
      )}
      <div className="chart-menu_charts">
        {tiles.map((tile) => (
          <a
            key={tile.ticker}
            className={classnames('chart-menu_chart-preview', { 'is-active': tile.ticker === activeTile })}
            href={getTileHref(tile.ticker)}
          >
            <span>{tile.label}</span>
            <Sparkline width={88} height={28} data={tile.sparkline} />
          </a>
        ))}
      </div>
      <div className="clearfix"></div>
    </div>
  )
}
